import React from 'react';
import '../styles/footer.scss';
import logo from '../assets/brandBlack.svg';

function Footer() {
  return (
    <div className="Footer">
      <div className="listSocial">
        <a className="socialLinks" href="https://www.facebook.com/uQuest/">Facebook</a>
        <a className="socialLinks" href="https://twitter.com/uQuest_official">Twitter</a>
        <a className="socialLinksMiddle" href="https://www.instagram.com/uquest_official/">Instagram</a>
        <a className="socialLinksMiddle" href="https://www.youtube.com/channel/UCD9Ay5zSKh_3kAWIep56Lgw">
          YouTube
        </a>
        <a className="socialLinks" href="https://www.reddit.com/user/uQuest_official/">Reddit</a>
      </div>
      <div className="listMails">
        <a ><b>{'Partnerships & Roadmap'}</b></a>
        <a className="emailLinkBlack" href="mailto:partnerships@uquest.com?Subject=Partnership"> partnerships@uquest.com</a>
        <a className="emailTitleBlue" href="javascript:;"><b>Investments</b></a>
        <a className="emailLinkBlue" href="mailto:investments@uquest.com?Subject=Investment">investments@uquest.com</a>
        <a><b>General questions</b></a>
        <a className="emailLinkBlack" href="mailto:questions@uquest.com?Subject=Question">questions@uquest.com</a>
        <a className="emailTitleBlue" href="javascript:;"><b>Press</b></a>
        <a className="emailLinkBlue" href="mailto:press@uquest.com?Subject=Press">press@uquest.com</a>
      </div>
      <div className="footer-brand-container">
        <img className="footer-logo" src={logo} alt="Logo" />
      </div>
    </div>
  );
}

export default Footer;
